var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bbs_tit_g" }, [
    _c("div", { staticClass: "tit_info" }, [
      _c("strong", { staticClass: "tit_item" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("p", { staticClass: "desc_item" }, [_vm._v(_vm._s(_vm.description))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }